
import { localstore, logoutEvent, sessionstore } from 'lib/storagePolyfill';
import CustomerService from './CustomerService';
import UserMetrics from './UserMetrics';
import api from 'api';

const AppUtils = {

  logout(options, callback) {
    if (window.CANCEL_IDLE_TIMERS) {
      window.CANCEL_IDLE_TIMERS();
    }

    logoutEvent.set();

    api.sessionApi.logout();
    AppUtils.clearSavedData(options);

    if (callback) { callback(); }
  },

  getSubdomain() {
    return BPH_SUBDOMAIN;
  },

  getGroupSubdomain() {
    const parts = window.location.hostname.split('.');
    return parts.length > 2 ? parts[0] : '';
  },

  getGroupLoginUrl(subdomain) {
    const parts = window.location.host.split('.');
    parts[0] = subdomain;
    return `${window.location.protocol}//${parts.join('.')}/login`;
  },

  getBackpackGroupsUrl() {
    const parts = window.location.host.split('.');
    parts.shift();
    return `${window.location.protocol}//${parts.join('.')}`;
  },

  getQueryParams(query) {
    const queryString = query[0] === '?' ? query.slice(1, query.length) : query;
    const pairs = queryString.split('&');

    const queryParams = {};
    pairs.forEach(p => {
      const keyValue = p.split('=');
      queryParams[keyValue[0]] = keyValue[1];
    });

    return queryParams;
  },

  clearSavedData(options = { retainMetrics: false }) {
    localstore.clearAll();
    sessionstore.clearAll();
    CustomerService.shutdown();
    if (!options.retainMetrics) {
      UserMetrics.reset();
    }
  },

  formatSubdomain(subdomain) {
    let text = subdomain.toLowerCase();
    text = text.substr(0, 63);
    text = text.replace(/[^a-z0-9]+|\s+/gmi, '');
    return text;
  },

  cssColor(colorData) {
    return colorData ? `rgba(${colorData.r}, ${colorData.g}, ${colorData.b}, ${colorData.a})` : '';
  },

  rgbToHex(rgbaColorString) {
    const rgbaColorValues = rgbaColorString.split('(')[1].split(')')[0].split(',').map(n => Number(n));
    let r = rgbaColorValues[0].toString(16);
    let g = rgbaColorValues[1].toString(16);
    let b = rgbaColorValues[2].toString(16);
    // let a = Math.round(rgbaColorValues[3] * 255).toString(16);

    if (r.length == 1) {
      r = "0" + r;
    }
    if (g.length == 1) {
      g = "0" + g;
    }
    if (b.length == 1) {
      b = "0" + b;
    }
    // if (a.length == 1) {
    //   a = "0" + a;
    // }

    return ("#" + r + g + b).toUpperCase();
  },

  formatFileSize(size) {
    let unit = 'b';

    const sizeKiloBytes = size / 1000;
    const sizeMegaBytes = sizeKiloBytes / 1000;
    const sizeGigaBytes = sizeMegaBytes / 1000;
    const sizeTeraBytes = sizeGigaBytes / 1000;

    if (sizeTeraBytes >= 1) {
      size = sizeTeraBytes;
      unit = 'TB';
    } else if (sizeGigaBytes >= 1) {
      size = sizeGigaBytes;
      unit = 'GB';
    } else if (sizeMegaBytes >= 1) {
      size = sizeMegaBytes;
      unit = 'MB';
    } else if (sizeKiloBytes >= 1) {
      size = sizeKiloBytes;
      unit = 'KB';
    }
    size = Number(size).toFixed(2);
    size = size % 1 === 0 ? parseInt(Math.floor(size), 10) : parseFloat(size, 10);

    return `${size}${unit}`;
  },

}

export default AppUtils;
